// Default service images (public URLs or import your own assets)
export const DEFAULT_SERVICE_IMAGES = [
  'https://res.cloudinary.com/dp8bfdbab/image/upload/v1710000000/service-website.png',
  'https://res.cloudinary.com/dp8bfdbab/image/upload/v1710000000/service-webapp.png',
  'https://res.cloudinary.com/dp8bfdbab/image/upload/v1710000000/service-mobile.png',
  'https://res.cloudinary.com/dp8bfdbab/image/upload/v1710000000/service-cyber.png',
  'https://res.cloudinary.com/dp8bfdbab/image/upload/v1710000000/service-marketing.png',
  'https://res.cloudinary.com/dp8bfdbab/image/upload/v1710000000/service-editing.png',
];
